<template>
    <div>
        <div class="main-box mh-a pc-hidden">
            <div class="ovh  programme">
                <div class="iristar-programme p-r c-pointer" v-for="(item, index) in programmeArr"
                    :key="`${index}_programme`"
                    :style="`background-image: url(/static/img/programme/programme${item.name}.png)`" @click="
                    $router.push({
                        path: `/solution-details/${item.name}`,
                    })
                    ">
                    <div class="mask"></div>
                    <div class="fs24 p-a text-center c-white mask-info pv10 transtion">
                        <h4 class="mb6">
                            {{ $t(`programme.${item.name}`) }}
                        </h4>
                        <!-- <p class="fs14 lh30" v-html="$t(`programmeInfo.${item.name}`)"></p> -->
                    </div>
                </div>
            </div>
        </div>
        <el-row class="mobil">
            <el-col :span="8" v-for="(item, index) in programmeArr" :key="`${index}_pro`" @click.native="
                    $router.push({
                        path: `/solution-details/${item.name}`,
                    })
                    " :style="`background-image: url(/static/img/programme/programme${item.name}.png)`"
                class="c-pointer mobil-pro p-r">
                <div class="mask"></div>
                <div class="p-a text-center c-white pro-text">
                    <h4 class="fs24">
                        {{ $t(`programme.${item.name}`) }}
                    </h4>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: "IristarProgramme",
    props: {
        programmeArr: {
            type: Array,
            default: () => {
                return [
                    // {
                    //     label: "软件系统",
                    //     name: "programme1",
                    // },
                    // {
                    //     label: "AI算法平台",
                    //     name: "programme2",
                    // },
                    // {
                    //     label: "智能硬件",
                    //     name: "programme3",
                    // },
                    {
                        label: "企业级车间智能化服务",
                        name: "4",
                    },
                    {
                        label: "企业级实验室智能化服务",
                        name: "5",
                    },
                    {
                        label: "科研级实验室智能化服务",
                        name: "6",
                    },
                    {
                        label: "医疗实验室智能化服务",
                        name: "7",
                    },
                    {
                        label: "公共服务平台智能化服务",
                        name: "8",
                    },
                    {
                        label: "定制化服务",
                        name: "9",
                    },
                ];
            },
        },
    },
};
</script>

<style></style>
